(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4611],{

/***/ 77794:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/web/online-load-booking",
      function () {
        return __webpack_require__(24803);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 24803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ OnlineLoadBookingPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _components_service_pages_online_load_booking_OnlineLoadBooking__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51334);
/* harmony import */ var _components_service_pages_constants_onlineLoadBooking_constants_methods__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40537);




var __N_SSG = true;
function OnlineLoadBookingPage(param) {
    var faqs = param.faqs;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_service_pages_online_load_booking_OnlineLoadBooking__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        faqs: faqs
    });
};
OnlineLoadBookingPage.getLayout = _components_service_pages_constants_onlineLoadBooking_constants_methods__WEBPACK_IMPORTED_MODULE_3__/* .getOnlineLoadBookingPageLayout */ .X;


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4304,6090,7783,5689,3034,9774,2888,179], function() { return __webpack_exec__(77794); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);